import PharmacyTechniciansContainer from './pharmacy-technicians-container';

export default PharmacyTechniciansContainer;
